import script from "./WashingMarkContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./WashingMarkContent.vue?vue&type=script&lang=ts&setup=true"

import "./WashingMarkContent.vue?vue&type=style&index=0&id=8874ebfa&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8874ebfa"]])

export default __exports__